(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // ===================================================
  // SCRIPT POUR EFFET AU SCROLL
  // ===================================================
  
  // Fonction pour ajouter/retirer la classe 'scrolled' au header
  function handleScroll() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;
    
    if (window.scrollY > 50) {
      headerWrapper.classList.add('scrolled');
    } else {
      headerWrapper.classList.remove('scrolled');
    }
  }
  
  // Écouter l'événement scroll
  window.addEventListener('scroll', handleScroll);
  
  // Vérifier au chargement de la page
  handleScroll();
  
  // ===================================================

  // ===================================================
  // SCRIPT POUR CHANGER LE HEADER EN ROSE QUAND MENU OUVERT
  // ===================================================
  
  document.addEventListener('DOMContentLoaded', function() {
    const headerWrapper = document.querySelector('.header-wrapper');
    const menuDrawer = document.querySelector('#Details-menu-drawer-container');
    
    if (!headerWrapper || !menuDrawer) {
      console.log('Elements not found:', { headerWrapper, menuDrawer });
      return;
    }
    
    console.log('Menu observer initialized');
    
    // Observer pour détecter quand l'attribut 'open' change
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (menuDrawer.hasAttribute('open')) {
            // Menu ouvert - ajouter la classe
            console.log('Menu opened - adding menu-open class');
            headerWrapper.classList.add('menu-open');
          } else {
            // Menu fermé - retirer la classe
            console.log('Menu closed - removing menu-open class');
            headerWrapper.classList.remove('menu-open');
          }
        }
      });
    });
    
    // Observer les changements d'attributs sur le details
    observer.observe(menuDrawer, {
      attributes: true,
      attributeFilter: ['open']
    });
    
    // Vérifier l'état initial
    if (menuDrawer.hasAttribute('open')) {
      console.log('Menu initially open');
      headerWrapper.classList.add('menu-open');
    }
    
    // Aussi écouter les clics sur le summary pour une réaction immédiate
    const menuToggle = menuDrawer.querySelector('summary');
    if (menuToggle) {
      menuToggle.addEventListener('click', function() {
        // Petit délai pour laisser l'attribut open se mettre à jour
        setTimeout(function() {
          if (menuDrawer.hasAttribute('open')) {
            headerWrapper.classList.add('menu-open');
          } else {
            headerWrapper.classList.remove('menu-open');
          }
        }, 10);
      });
    }
  });
  
  // ===================================================

  // ===================================================
  // SCRIPT DE REDIRECTION PERSONNALISÉE POUR LES LANGUES
  // ===================================================
  
  document.addEventListener('DOMContentLoaded', function() {
    const languageSwitchers = document.querySelectorAll('.language-switcher-link');
    
    languageSwitchers.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        const languageCode = this.getAttribute('data-language-code');
        let currentPath = window.location.pathname;
        let currentSearch = window.location.search;
        let currentHash = window.location.hash;
        
        // Supprimer les préfixes de langue existants
        currentPath = currentPath.replace(/^\/(fr|en|es)(\/|$)/, '/');
        
        // Construire la nouvelle URL selon la langue
        let newPath;
        if (languageCode === 'es') {
          // Espagnol = langue par défaut, pas de préfixe
          newPath = currentPath;
        } else if (languageCode === 'fr') {
          // Français = /fr
          newPath = '/fr' + currentPath;
        } else if (languageCode === 'en') {
          // Anglais = /en
          newPath = '/en' + currentPath;
        } else {
          // Autre langue = /{code}
          newPath = '/' + languageCode + currentPath;
        }
        
        // S'assurer qu'il n'y a pas de double slash
        newPath = newPath.replace(/\/\//g, '/');
        
        // Rediriger vers la nouvelle URL
        window.location.href = newPath + currentSearch + currentHash;
      });
    });
  });
  



  // ===================================================
  // TRANSFORMER LES H2 EN P POUR LE SEO
  // ===================================================
  
  document.addEventListener('DOMContentLoaded', function() {
    // Attendre un peu pour s'assurer que tout est chargé
    setTimeout(function() {
      // Sélectionner tous les H2 dans le header
      const headerH2s = document.querySelectorAll('.header h2, .menu-drawer h2, .localization-form h2, .search-modal h2, .header-wrapper h2');
      
      headerH2s.forEach(function(h2) {
        // Créer un nouveau paragraphe
        const p = document.createElement('p');
        
        // Copier tous les attributs
        for (let i = 0; i < h2.attributes.length; i++) {
          const attr = h2.attributes[i];
          p.setAttribute(attr.name, attr.value);
        }
        
        // Copier le contenu HTML
        p.innerHTML = h2.innerHTML;
        
        // Remplacer le H2 par le P
        h2.parentNode.replaceChild(p, h2);
      });
      
      console.log('H2 dans le header transformés en P');
    }, 100);
  });
  // ===================================================

  } catch(e) { console.error(e); }
})();
})();
